export default __webpack_public_path__ + "static/media/Product Branding.e7b53d0f.jpg";